<div class="container my-4">
  <div class="loading-mask" *ngIf="showSpinner">
    <mat-spinner diameter="50" strokeWidth="3"></mat-spinner>
  </div>

  <div class="page-header">
    <button mat-button class="back-button" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      {{ 'ESIM.MY_ESIM' | translate }}
    </button>
    <h2>{{ 'ESIM.TOPUPS_AVAILABLE' | translate }}</h2>
  </div>

  <h3 class="section-title" *ngIf="esimDetails">{{ 'ESIM.DETAILS.CURRENT_STATUS' | translate }}</h3>

  <div *ngIf="esimDetails" class="grid grid-cols-1 gap-4 mx-auto">
    <mat-card class="esim-card" appearance="outlined">

      <mat-card-header class="mb-2 flex justify-center items-top">
        <div class="absolute left-0 ml-4 p-2 flex" style="height:fit-content;">
          <div *ngFor="let item of esimDetails.pkg_details.operator_info.plan_type.split('-')">
            <img width="16" [src]="'./assets/icons/' + item + '_ico.svg'" title="{{ item }}" class="mx-1" />
          </div>
        </div>
        <div class="rounded-full bg-white absolute right-0 mr-4 p-2" style="height:fit-content;">
          <span class=" flag large block content-center"><img src="{{ esimDetails.pkg_details.country_url }}" /></span>
        </div>

        <div class="esim-my-card-image-container relative ml-4">
          <img src="https://cdn-dev.zendy.tel/images/Esim/EsimCard@2x.png" alt="SIM Card" class="esim-my-card-image" />
          <span class="esim-my-country-label">{{ esimDetails.country }}</span> <!-- Nombre del país en la imagen -->
        </div>
      </mat-card-header>

      <mat-card-content>
        <mat-card-subtitle class="font-bold text-center">{{ esimDetails.details.iccid }}</mat-card-subtitle>
        <mat-card-title class="font-bold text-center">{{ esimDetails.country | titlecase }}</mat-card-title>
        <mat-card-subtitle class="text-center mb-3"><span class="font-bold">{{ "ESIM.PURCHASE_DETAILS.VALIDITY" | translate }}:</span> {{ esimDetails.validity }}</mat-card-subtitle>

        <!-- Datos -->
        <div class="progress-section" *ngIf="(esimDetails.usage_data?.total != 0)">
          <div class="label-container">
            <strong>{{ 'ESIM.DATA' | translate }}:</strong>
            <p class="item-value right-align">
              {{ 'ESIM.USED' | translate }}: {{ esimDetails.usage_data?.total ? esimDetails.usage_data.total - esimDetails.usage_data.remaining : 0 }}MB
              {{ 'ESIM.OF' | translate }} {{ esimDetails.usage_data?.total ? esimDetails.usage_data.total : 0 }}MB
            </p>
          </div>
          <mat-progress-bar mode="determinate"
                            [value]="calculatePercentage(esimDetails.usage_data?.total, esimDetails.usage_data?.remaining)"
                            class="progress-bar"></mat-progress-bar>
        </div>

        <!-- Voz -->
        <div class="progress-section" *ngIf="(esimDetails.usage_data?.total_voice != 0)">
          <div class="label-container">
            <strong>{{ 'ESIM.VOICE' | translate }}:</strong>
            <p class="item-value right-align">
              {{ 'ESIM.USED' | translate }}: {{ esimDetails.usage_data?.total_voice ? esimDetails.usage_data.total_voice - esimDetails.usage_data.remaining_voice : 0 }}
              min {{ 'ESIM.OF' | translate }} {{ esimDetails.usage_data?.total_voice ? esimDetails.usage_data.total_voice : 0 }} min
            </p>
          </div>
          <mat-progress-bar mode="determinate"
                            [value]="calculatePercentage(esimDetails.usage_data?.total_voice, esimDetails.usage_data?.remaining_voice)"
                            class="progress-bar"></mat-progress-bar>
        </div>

        <!-- SMS -->
        <div class="progress-section" *ngIf="(esimDetails.usage_data?.total_text != 0)">
          <div class="label-container">
            <strong>SMS:</strong>
            <p class="item-value right-align">
              {{ 'ESIM.USED' | translate }}: {{ esimDetails.usage_data?.total_text ? esimDetails.usage_data.total_text - esimDetails.usage_data.remaining_text : 0 }}
              {{ 'ESIM.OF' | translate }} {{ esimDetails.usage_data?.total_text ? esimDetails.usage_data.total_text : 0 }}
            </p>
          </div>
          <mat-progress-bar mode="determinate"
                            [value]="calculatePercentage(esimDetails.usage_data?.total_text, esimDetails.usage_data?.remaining_text)"
                            class="progress-bar"></mat-progress-bar>
        </div>
      </mat-card-content>

    </mat-card>
  </div>

  <h3 class="section-title section-title--topups">{{ 'ESIM.TOPUPS_AVAILABLE' | translate }}</h3>

  <div *ngIf="loadingTopups" class="topups-loading">
    <mat-spinner diameter="40" strokeWidth="3"></mat-spinner>
    <p>{{ 'ESIM.LOADING_TOPUPS' | translate }}</p>
  </div>

  <div *ngIf="!loadingTopups && topups.length > 0" class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
    <mat-card *ngFor="let topup of topups" class="lg:max-w-[450px] esim-card {{ topups.length > 1 ? '' : 'esim-card-single' }}" appearance="outlined">
      <mat-card-header class="flex items-start">
        <div class="header-image-container !mr-4">
          <img mat-card-image src="https://cdn-dev.zendy.tel/images/Esim/EsimCard@2x.png" alt="{{ topup.operator }}" class="sim-card-image-small">
        </div>
        <div>
          <h2 class="text-black m-0 text-xl">{{ topup.title }}</h2>
          <h2 class="m-0 text-xl">{{ topup.price | currency:'EUR':'symbol':'1.2-2':'es-ES' }}</h2>
          <div class="flex" style="height:fit-content;">
            <mat-icon class="text-red-700">autorenew</mat-icon>
          </div>
        </div>
      </mat-card-header>

      <hr>

      <mat-card-content>
        <div class="item-detail flex items-center my-1">
          <mat-icon class="text-red-700">swap_horiz</mat-icon>
          <label class="item-label font-bold mx-1">{{ 'ESIM.DATA' | translate }}: </label>
          <span class="item-value">{{ topup.data }}</span>
        </div>
        <div class="item-detail flex items-center my-1">
          <mat-icon class="text-red-700">sim_card</mat-icon>
          <label class="item-label font-bold mx-1">{{ 'ESIM.TYPE' | translate }}: </label>
          <span class="item-value">{{ "ESIM."+topup.type | uppercase | translate }}</span>
        </div>
        <div class="item-detail flex items-center mt-1">
          <mat-icon class="text-red-700">date_range</mat-icon>
          <label class="item-label font-bold mx-1">{{ 'ESIM.VALIDITY' | translate }}: </label>
          <span class="item-value">{{ topup.day }} {{ topup.day > 1 ? ('ESIM.DAYS' | translate) : ('ESIM.DAY' | translate) }}</span>
        </div>
      </mat-card-content>

      <mat-card-actions>
        <div class="buybutton mt-4 mx-auto">
          <button mat-button class="buy-button" (click)="sendToProfile ? openProfileModal() : submitTopUp(topup.id)">{{ 'ESIM.RECHARGE_NOW' | translate }}</button>
        </div>
      </mat-card-actions>
    </mat-card>

  </div>

  <div *ngIf="!loadingTopups && topups.length === 0" class="empty-topups-state">
    <mat-icon class="empty-topups-icon">sim_card</mat-icon>
    <p>{{ 'ESIM.NO_TOPUPS_AVAILABLE' | translate }}</p>
  </div>
</div>
